import { jsx } from "react/jsx-runtime";
import SearchIcon from "@mui/icons-material/Search";
import { validateTidalLicense } from "../../base/index.js";
function Search(props) {
  return /* @__PURE__ */ jsx(
    SearchIcon,
    {
      "data-testid": "Search",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Search",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
Search.tidalIconMeta = {
  categories: "common,navigation",
  name: "Search"
};
validateTidalLicense();
export {
  Search
};
//# sourceMappingURL=Search.js.map
